import Homepage from './Homepage.vue';

export default Homepage;
